import React from 'react';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, Typography, IconButton } from '@mui/material';
import { Add, Edit, BluetoothSearching } from '@mui/icons-material';

export const HardwareRegistry = () => (
  <Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',mb: 2, mt: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 800, letterSpacing: -0.5 }}>Hardware Registry</Typography>
      <Button variant="contained" startIcon={<Add />}>Register Truck</Button>
    </Box>
 
  <Card>

    <TableContainer>
      <Table>
        <TableHead sx={{ bgcolor: '#f8fafc' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 800 }}>TRUCK ID</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>METER TYPE</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>PRINTER</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>BT MAC ADDRESS</TableCell>
            <TableCell align="right">ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow hover>
            <TableCell sx={{ fontWeight: 700 }}>TK-904</TableCell>
            <TableCell>iMeter v2 (Oil)</TableCell>
            <TableCell>Zebra ZQ520</TableCell>
            <TableCell sx={{ fontFamily: 'monospace', color: 'primary.main' }}>00:1A:2B:3C:4D</TableCell>
            <TableCell align="right"><IconButton size="small"><Edit /></IconButton></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </Card>
   </Box>
);